import {
  DimensionValue,
  Modal,
  Pressable,
  StyleSheet,
  View,
} from "react-native";
import { Box, TouchableBox } from "./AHTheme/Box";
import { useScaleFactor } from "./AHScaleFactor";
import { AHText } from "./Text/AHText";
import { Circle } from "./AHTheme/Circle";
import { AHIcon } from "./AHIcon";
import { useLayoutContext } from "./LayoutProvider";

export function Dialog(props: {
  children: React.ReactNode;
  visible: boolean;
  onClose?: () => void;
  minHeight?: DimensionValue;
  height?: DimensionValue;
  maxHeight?: DimensionValue;
  title?: React.ReactNode;
  customTitle?: React.ReactNode;
  view?: React.ComponentType;
}) {
  const sf = useScaleFactor();
  const layout = useLayoutContext();

  const V = props.view || View;
  return (
    <Modal
      visible={props.visible}
      transparent
      presentationStyle="overFullScreen"
      supportedOrientations={["portrait", "portrait-upside-down", "landscape-left", "landscape-right"]}
      animationType={
        process.env.EXPO_PUBLIC_DEVICE_PLATFORM_TV !== "true" ? "fade" : "none"
      }
      onRequestClose={props.onClose}
      allowSwipeDismissal
      style={{ flex: 1 }}
    >
      <Box
        style={[
          StyleSheet.absoluteFill,
          {
            justifyContent: "center",
            alignItems: "center",
          },
        ]}
      >
        <Pressable
          style={[StyleSheet.absoluteFill]}
          onPress={() => {
            props.onClose?.();
          }}
        >
          <View
            style={[
              StyleSheet.absoluteFill,
              {
                backdropFilter:
                  process.env.EXPO_PUBLIC_DEVICE_PLATFORM_TV !== "true"
                    ? "blur(1.6px)"
                    : undefined,
                background: "rgba(0,0,0,0.1)",
                backgroundColor: "rgba(0,0,0,0.2)",
              } as any,
            ]}
          />
        </Pressable>

        <V
          style={[
            {
              minHeight: props.minHeight ?? 300 * sf,
              height: props.height,
              maxHeight: props.maxHeight ?? "80%",
              maxWidth: 430 * sf,
              width: "100%",
              paddingHorizontal: layout.space.medium,
            },
          ]}
        >
          <Box
            color="surface-primary"
            cornerRadius="large"
            style={{
              flex: 1,
              overflow: "hidden",
            }}
          >
            <Box
              space="medium"
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {props.customTitle ? (
                props.customTitle
              ) : (
                <AHText type="title-small" color="text-secondary">
                  {props.title}
                </AHText>
              )}
              {props.onClose ? (
                <TouchableBox
                  onPress={props.onClose}
                  hitSlop={{ left: 50, right: 20, top: 30, bottom: 10 }}
                >
                  <Circle size="smallMedium" color="background">
                    <AHIcon type="clear" size="small" color="text-primary" />
                  </Circle>
                </TouchableBox>
              ) : null}
            </Box>
            {props.children}
          </Box>
        </V>
      </Box>
    </Modal>
  );
}
